module.exports = __webpack_public_path__ + "img/icon-relabel.e72ce400.svg";